<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR PERÍODO' : 'NOVO PERÍODO'" titleIcon="fas fa-edit">

            <div v-if="modoEdicao && !carregado" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="dados.nome" maxlength="120" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Situação">
                            <el-select v-model="dados.situacao" style="width: 100%;">
                                <el-option :value="true" label="ATIVO"></el-option>
                                <el-option :value="false" label="INATIVO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Hora Início">
                            <el-time-picker v-model="dados.hora_inicio" value-format="HH:mm:ss" format="HH:mm" placeholder="Início" style="width: 100%;"></el-time-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Hora Fim">
                            <el-time-picker v-model="dados.hora_fim" value-format="HH:mm:ss" format="HH:mm" placeholder="Fim" style="width: 100%;"></el-time-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/periodo-referencia">
                            <el-button>VOLTAR</el-button>
                        </router-link>
                        <el-button class="u-ml-10" type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        dados: { nome: '', situacao: true, hora_inicio: null, hora_fim: null },
        modoEdicao: false,
        carregado: false
    }),
    mounted () {
        if (this.$route.params.id) {
            this.modoEdicao = true
            this.carregar(this.$route.params.id)
        }
    },
    methods: {
        carregar (id) {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/periodo-referencia/getById/${id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                this.dados.nome = reg.nome || ''
                this.dados.situacao = reg.situacao === false ? false : true
                this.dados.hora_inicio = reg.hora_inicio || null
                this.dados.hora_fim = reg.hora_fim || null
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/periodo-referencia/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/periodo-referencia/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.$router.push('/admin/periodo-referencia')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
